module.exports = __webpack_public_path__ + "img/jihe4.cf109c72.png";